<section class="page-title-area">
  <div class="card-header"></div>
  <span *ngIf="isLoading$ | async">
    <app-preloader [isFullPreloader]="true" />
  </span>
  <div class="card-body">
    <div class="container add-story-container">
      <form
        [formGroup]="addSuccessStoryFormGroup"
        #formDirective="ngForm"
        (ngSubmit)="onSubmit(formDirective)"
        class="example-form">
        <div>
          <h3 style="text-align: center">
            {{ isEditing ? 'Edit New Success Story' : 'Add New Success Story' }}
          </h3>
          <div style="text-align: center; padding-bottom: 30px">
            Note: Please reference other success stories for ideas and format
          </div>
          <div class="mat-form-field-wrapper">
            <mat-form-field
              appearance="outline"
              class="form-element"
              subscriptSizing="fixed">
              <mat-label
                >Title *
                <i
                  class="fa fa-info-circle"
                  matTooltip="Title of the success story"></i
              ></mat-label>
              <input matInput type="text" formControlName="title" />
              <mat-error
                *ngIf="title.invalid && (title.dirty || title.touched)">
                @if (getError('title')?.required) {
                  Title is required
                } @else {
                  &nbsp;
                }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="mat-form-field-wrapper">
            <mat-form-field appearance="outline" class="form-element">
              <mat-label
                >Short Description *
                <i
                  class="fa fa-info-circle"
                  matTooltip="Short Description of the success story"></i
              ></mat-label>
              <input matInput formControlName="short_description" />
              <mat-error
                *ngIf="
                  shortDescription.invalid &&
                  (shortDescription.dirty || shortDescription.touched)
                ">
                @if (getError('short_description')?.required) {
                  Short Description is required
                } @else {
                  &nbsp;
                }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="mat-form-field-wrapper">
            <mat-label
              class="input-label-mat"
              [ngClass]="
                businessChallenges.invalid &&
                (businessChallenges.dirty || businessChallenges.touched) &&
                getError('business_challenges')
                  ? 'input-label-mat--invalid'
                  : ''
              ">
              Business Challenges *
              <i
                class="fa fa-info-circle"
                matTooltip="Briefly describe the issue/problem/opportunity identified"></i
            ></mat-label>
            <ngx-editor-menu
              [editor]="businessChallengesEditor"
              [toolbar]="toolbar" />
            <ngx-editor
              [editor]="businessChallengesEditor"
              formControlName="business_challenges" />
            <mat-error
              *ngIf="
                businessChallenges.invalid &&
                (businessChallenges.dirty || businessChallenges.touched)
              ">
              @if (getError('business_challenges')?.required) {
                Business challenges is required
              } @else {
                &nbsp;
              }
            </mat-error>
          </div>
          <div class="mat-form-field-wrapper">
            <mat-label
              class="input-label-mat"
              [ngClass]="
                solutions.invalid &&
                (solutions.dirty || solutions.touched) &&
                getError('solutions')
                  ? 'input-label-mat--invalid'
                  : ''
              ">
              Solutions *
              <i
                class="fa fa-info-circle"
                matTooltip="Briefly describe solution deployed - outline actions/steps/process used to achieve the desired outcome - including alternatives evaluated if applicable"></i>
            </mat-label>
            <ngx-editor-menu [editor]="solutionsEditor" [toolbar]="toolbar" />
            <ngx-editor
              [editor]="solutionsEditor"
              formControlName="solutions" />
            <mat-error
              *ngIf="
                solutions.invalid && (solutions.dirty || solutions.touched)
              ">
              @if (getError('solutions')?.required) {
                Solutions is required
              } @else {
                &nbsp;
              }
            </mat-error>
          </div>
          <div class="mat-form-field-wrapper">
            <mat-label
              class="input-label-mat"
              [ngClass]="
                benefitsResults.invalid &&
                (benefitsResults.dirty || benefitsResults.touched) &&
                getError('benefits_results')
                  ? 'input-label-mat--invalid'
                  : ''
              ">
              Benefits And Results *
              <i
                class="fa fa-info-circle"
                matTooltip="Briefly describe benefits and business results achieved - cost saving, FTE savings, other KPIs as applicable, etc."></i>
            </mat-label>
            <ngx-editor-menu
              [editor]="benefitsAndResultsEditor"
              [toolbar]="toolbar" />
            <ngx-editor
              [editor]="benefitsAndResultsEditor"
              formControlName="benefits_results" />
            <mat-error
              *ngIf="
                benefitsResults.invalid &&
                (benefitsResults.dirty || benefitsResults.touched)
              ">
              @if (getError('benefits_results')?.required) {
                Benefits and results is required
              } @else {
                &nbsp;
              }
            </mat-error>
          </div>
          <div>
            <h5 class="form-section-titile">Media</h5>
            @if (coverImage?.value || currentCoverImageURL) {
              <div class="card m-2">
                <h5 class="card-header">Current Cover Image</h5>
                <div class="card-body image-preview">
                  <img
                    [src]="
                      coverImage?.value
                        ? coverImage?.value
                        : currentCoverImageURL
                    "
                    (error)="onPreviewError($event, 'coverImage')" />
                </div>
              </div>
            }
            <div class="mat-form-field-wrapper">
              <app-upload
                label="Cover Image"
                requiredFileType="image/*"
                [fileName]="coverImage.value"
                [isErroring]="
                  coverImage.invalid && (coverImage.dirty || coverImage.touched)
                "
                (fileOutputEvent)="onCoverImageSelected($event)"
                errorMessage="Cover image is required"></app-upload>
            </div>
            <div class="card m-2">
              <h5 class="card-header">Current Main Image</h5>
              <div
                *ngFor="let image of currentContentImagesURL"
                class="card-body image-preview">
                <img [src]="image" alt="image" />
              </div>
            </div>
            <div class="mat-form-field-wrapper">
              <app-upload
                label="Main Image"
                requiredFileType="image/*"
                [fileName]="contentImages.value"
                [isErroring]="
                  contentImages.invalid &&
                  (contentImages.dirty || contentImages.touched)
                "
                [isMultiple]="true"
                (fileOutputEvent)="onContentImageSelected($event)"
                errorMessage="Content Images is required"></app-upload>
            </div>
            @if (!!(video?.value || currentVideoURL)) {
              <div class="card m-2">
                <h5 class="card-header">Current Video</h5>
                <div class="card-body image-preview">
                  <video controls>
                    <source
                      [src]="currentVideoURL ? currentVideoURL : video?.value"
                      (error)="onPreviewError($event, 'video')" />
                  </video>
                </div>
              </div>
            }
            <div class="mat-form-field-wrapper">
              <app-upload
                label="Video"
                requiredFileType="video/*"
                [fileName]="video.value"
                [isErroring]="video.invalid && (video.dirty || video.touched)"
                (fileOutputEvent)="onVideoSelected($event)"
                errorMessage="Video is required"></app-upload>
            </div>
            <div class="submit-area">
              <button
                type="button"
                mat-fab
                extended
                (click)="onReset(formDirective)">
                Reset
              </button>
              <button
                type="submit"
                mat-fab
                extended
                color="primary"
                style="float: right">
                {{ isEditing ? 'Save changes' : 'Submit' }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
